"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = void 0;
const copyToClipboard = (text) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!text) {
        return;
    }
    if (typeof navigator !== 'undefined' && typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) === 'function') {
        try {
            yield navigator.clipboard.writeText(text);
        }
        catch (e) {
            return;
        }
        return;
    }
    const textarea = document.createElement('textarea');
    textarea.textContent = text;
    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand('copy'); // Security exception may be thrown by some browsers.
    }
    catch (e) {
        return;
    }
    finally {
        document.body.removeChild(textarea);
    }
});
exports.copyToClipboard = copyToClipboard;
//# sourceMappingURL=copyToClipboard.js.map